import { all, call, put, takeEvery } from "redux-saga/effects";
import { facilityCredentialService } from "@iso/services";
import actions from "./actions";

function* searchSaga({ payload }) {
  try {
    const response = yield call(facilityCredentialService.search, payload);
    yield put({
      type: actions.SEARCH_SUCCESS,
      items: response?.items ?? [],
      total: response?.total ?? 0,
    });
  } catch (error) {
    yield put({ type: actions.SEARCH_ERROR, error });
  }
}

function* detailSaga({ payload }) {
  const { facilityCredentialId, resolve, reject } = payload;
  try {
    const detail = yield call(facilityCredentialService.getDetail, {
      facilityCredentialId,
    });
    yield put({ type: actions.DETAIL_SUCCESS, detail });
    if (resolve) resolve(detail);
  } catch (error) {
    yield put({ type: actions.DETAIL_ERROR, error });
    if (reject) reject(error);
  }
}

function* createSaga({ payload }) {
  const { data, resolve, reject } = payload;
  try {
    const saved = yield call(facilityCredentialService.create, data);
    yield put({ type: actions.CREATE_SUCCESS });
    if (saved?.facilityCredentialId) {
      yield put({ type: actions.DETAIL_SUCCESS, detail: saved });
    }
    if (resolve) resolve(saved);
  } catch (error) {
    yield put({ type: actions.CREATE_ERROR, error });
    if (reject) reject(error);
  }
}

function* updateSaga({ payload }) {
  const { data, resolve, reject } = payload;
  try {
    const saved = yield call(facilityCredentialService.update, data);
    yield put({ type: actions.UPDATE_SUCCESS });
    if (saved?.facilityCredentialId) {
      yield put({ type: actions.DETAIL_SUCCESS, detail: saved });
    }
    if (resolve) resolve(saved);
  } catch (error) {
    yield put({ type: actions.UPDATE_ERROR, error });
    if (reject) reject(error);
  }
}

function* deleteSaga({ payload }) {
  const { facilityCredentialId, resolve, reject } = payload;
  try {
    yield call(facilityCredentialService.delete, { facilityCredentialId });
    yield put({ type: actions.DELETE_SUCCESS });
    if (resolve) resolve();
  } catch (error) {
    yield put({ type: actions.DELETE_ERROR, error });
    if (reject) reject(error);
  }
}

export default function* facilityCredentialSagas() {
  yield all([
    takeEvery(actions.SEARCH_REQUEST, searchSaga),
    takeEvery(actions.DETAIL_REQUEST, detailSaga),
    takeEvery(actions.CREATE_REQUEST, createSaga),
    takeEvery(actions.UPDATE_REQUEST, updateSaga),
    takeEvery(actions.DELETE_REQUEST, deleteSaga),
  ]);
}
